import { useContent } from "@/context/ContentContext";
import { fileUrl } from "@/lib/api";
import { Download, FileText } from "lucide-react";

export default function BrochureMediaKit() {
  const content = useContent();
  const MEDIA_IMAGE = content.media_kit_image_url || content.cover_image_url;
  const pdf = content.media_kit_pdf_url;
  return (
    <div data-testid="brochure-media-kit-page">
      <div className="max-w-7xl mx-auto px-6 py-14 grid lg:grid-cols-2 gap-12 items-center">
        <div className="flex justify-center">
          <img src={fileUrl(MEDIA_IMAGE)} alt="BSD Media Kit" className="rounded-lg shadow-2xl max-h-[520px] w-auto" />
        </div>
        <div>
          <div className="space-y-3">
            {pdf ? (
              <a href={fileUrl(pdf)} download target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 rounded-xl border border-[#800020] bg-[#800020] text-white p-4 hover:bg-[#660019] transition-colors" data-testid="media-download-pdf">
                <span className="h-11 w-11 rounded-lg bg-white/15 flex items-center justify-center"><Download className="h-5 w-5" /></span>
                <span className="font-medium">Download Media Kit (PDF)</span>
              </a>
            ) : (
              <div className="flex items-center gap-3 rounded-xl border border-dashed border-slate-300 bg-white p-4 text-slate-400" data-testid="media-download-empty">
                <FileText className="h-5 w-5" />
                <span className="text-sm">Media Kit PDF will be available soon.</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
